import { DictContext } from "@/layout/context/DictContext";
import { Select, SelectProps } from "antd";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

type SelectShipEventPros<T> = Omit<SelectProps<T>, "options">

function SelectShipEvent<T>(props: SelectShipEventPros<T>) {
  const { t } = useTranslation();
  const { shipEvents } = useContext(DictContext);
  
  return (
    <Select
      {...props}
      options={
        shipEvents.map(type => ({ key: type.key, label: type.desc, value: type.key }))
      }
      placeholder={t('shipment.shipEvent')}
    />
  )
};

export default SelectShipEvent;
